<script>
import formdate from "@/router/views/formcomponet/formdate.vue";
import forminput from "@/router/views/formcomponet/forminput.vue";
import formtextarea from "@/router/views/formcomponet/formtextarea.vue";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import tlptalep from "@/models/tlptalep";
import useVuelidate from "@vuelidate/core";
import addedit from "./addedit";
export default {
  mixins: [Api, Sabit, tlptalep],
  page: {
    title: "Talepler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    forminput,
    formtextarea,
    formdate, treeselect,addedit
  },
  data() {
    return {
      title: "Talep Detay",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Talepler",
          active: true,
        },
        {
          text: "Talep Detay",
          active: true,
        },
      ],
      v$: useVuelidate(),
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      FILES_URL: JSON.parse(localStorage.getItem("config")).FILES_URL,
      Talepid: this.$route.params.Talepid,
      TalepData: null,
      TalepBelgeler: [],
      TalepBildirim: [],
      TalepGecmis: [],
      TalepNot: [],
      Mesaj: null,
      FormData: {},
      Belgeurl: null,
      BelgeBaslik: null,
      HazirYanitlar: [],
      HazirYanit: null,
      TalebiKapat: false,
      Cozulmedi: true,
      ToDoFormData: { 
                    Metin: "",
                    Durum: false, 
                  },
      ToDoList: {},
      isSubmitting: false,
      YonetimYetki: false,
      
      Belgeler: [],
      BildirimMesaji: null,
      ModalOpen: false,
      BildirimButton: false,
      
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE
    };
  },
  watch: {
    HazirYanit() {
      if (this.HazirYanit != null) {
        this.Mesaj = this.HazirYanitlar.find(item => item.id === this.HazirYanit).metin

      }
    }
  },
  methods: {

    async Get() {
      this.isSubmitting = false
      var res = await this.ActionsFilterGet({
        Service: "tlptalep",
        FullData: true,
        Filter: "&Id=" + this.Talepid,
      })

      if(!this.YonetimYetki && res.Data[0].Olusturanid != this.TokenPersonelId){
        this.$router.push('/');
      }

      this.TalepData = res.Data[0]; 
      this.FormData = res.Data[0];
      this.loading = false


      this.FormDataType.Baslik.Disabled = true
        this.FormDataType.Aciklama.Disabled = true
        this.FormDataType.Tahminibitis.Disabled = true
        this.FormDataType.Taleptipid.Disabled = true
        this.FormDataType.Atananbirimid.Disabled = true
        this.FormDataType.Durumid.Disabled = true
        this.FormDataType.Oncelikid.Disabled = true
        this.FormDataType.Atananpersonelid.Disabled = true
        this.FormDataType.Olusturanid.Disabled = true
        this.Cozulmedi = false




      await this.ActionsFilterGet({
        Service: "tlptalepbildirim",
        FullData: true,
        Filter: "&Talepid=" + this.Talepid,
      }).then((res) => {
        this.TalepBildirim = res.Data;
      });
      await this.ActionsFilterGet({
        Service: "tlptalepgecmis",
        FullData: true,
        Filter: "&Desc=Created&Talepid=" + this.Talepid,
      }).then((res) => {
        this.TalepGecmis = res.Data;
      });
      await this.TalepBelgeGet()
      await this.TalepNotGet()
      await this.ToDoGet()
    },
    TalepBelgeGet() {
      this.ActionsFilterGet({
        Service: "tlptalepbelge",
        FullData: true,
        Filter: "&Desc=Created&Talepid=" + this.Talepid,
      }).then((res) => {
        this.TalepBelgeler = res.Data;
      });
    },
    TalepNotGet() {

      this.ActionsFilterGet({
        Service: "tlptalepnot",
        FullData: true,
        Filter: "&Desc=Created&Talepid=" + this.Talepid,
      }).then((res) => {
        this.TalepNot = res.Data;
        this.loading = false
      });
    },
    NotGonder() {

      if (!this.Mesaj) {
        this.$toast.error("Mesaj Giriniz");
        return
      }
      this.isSubmitting = true
      var FormData = {
        Talepid: this.Talepid,
        Aciklama: this.Mesaj,
        Olusturanid: this.TokenPersonelId,
      }
      this.Post("tlptalepnot", FormData).then((res) => {
        if (res) {
          this.Mesaj = null;
         

                if(this.Belgeler.length > 0 ){
          
                        var FormData = []
                          this.Belgeler.forEach(item => {
                            FormData.push({
                              Talepnotid: res,
                              Baslik: item.Filename,
                              Olusturanid: this.TokenPersonelId,
                              Dosyayolu: item.Fileurl
                            })
                          })
                          this.PostList("tlptalepbelge/postlist", FormData, false).then((res) => {
                            if (res) {
                              this.Belgeler = []
                            }
                            this.TalepNotGet()
                          })
                        
                }
                else{
                  this.TalepNotGet()
                }
                          
          if (this.TalebiKapat) {
            this.FormData.Durumid = this.FormDataType.Durumid.ComboDataArray.find(item => item.Kod === "7").id
            this.Update("tlptalep", this.FormData).then((res) => {
              if (res) {
                this.Get()
 
              }
            });
          }
        }
      });
    },
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {

        this.FormData.Lastmodifiedby = this.TokenUserId
        this.Update("tlptalep", this.FormData).then((res) => {
          if (res) {
            this.Get()
          }
        });

      }
    },
    FileUpload(event, Id) {
      var file = event.target.files[0];
      if (!file) return;

      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (uzanti == "png" || uzanti == "jpeg" || uzanti == "jpg" || uzanti == "docx" || uzanti == "xlsx" || uzanti == "pdf"  || uzanti == "tar" || uzanti == "zip") {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Tlp",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {
            if (Id) {
              var FormData = {
                Talepnotid: Id,
                Baslik: file.name,
                Olusturanid: this.TokenPersonelId,
                Dosyayolu: res.Data.filename
              }
              this.Post("tlptalepbelge", FormData).then((res) => {
                if (res) {
                  this.TalepNotGet()
                }
              });
            }
            else {
              this.Belgeurl = res.Data.filename;
              this.$toast.success("Dosya yüklendi");
            }
          } else {
            this.$toast.error("Dosya yüklenmedi!");
          }
        });
      }
      else {
        this.$toast.error("Hatalı Dosya Uzantısı!");
      }
    },
    BelgeGonder() {

      if (!this.BelgeBaslik) {
        this.$toast.error("Başlık Giriniz");
        return
      }
      if (!this.Belgeurl) {
        this.$toast.error("Belge Giriniz");
        return
      }
      var FormData = {
        Talepid: this.Talepid,
        Baslik: this.BelgeBaslik,
        Olusturanid: this.TokenPersonelId,
        Dosyayolu: this.Belgeurl
      }
      this.Post("tlptalepbelge", FormData).then((res) => {
        if (res) {
          this.BelgeBaslik = null;
          this.Belgeurl = null;
          this.TalepNotGet()
        }
      });
    },
    ToDoGet() {
      this.ActionsFilterGet({
        Service: "tlptaleptodolist",
        FullData: true,
        Filter: "&Desc=Created&Talepid=" + this.Talepid,
      }).then((res) => {
        this.ToDoList = res.Data;
      });
    },
    ToDoGonder() {

      if (!this.ToDoFormData.Metin) {
        this.$toast.error("Metin Giriniz");
        return
      }
 
        this.ToDoFormData.Talepid = this.Talepid 
        this.ToDoFormData.Personelid= this.TokenPersonelId
      if(!this.ToDoFormData.Id){ 
          this.Post("tlptaleptodolist", this.ToDoFormData).then((res) => {
            if (res) {
              this.ToDoFormData = {
                    Talepid: null,
                    Metin: "",
                    Durum: false,
                    Personelid: null
                  }
              this.ToDoGet()
            }
          });
        }
        else{ 
            this.Update("tlptaleptodolist", this.ToDoFormData)
              this.ToDoFormData = {
                    Talepid: null,
                    Metin: "",
                    Durum: false,
                    Personelid: null
                  }
        }
    },
    ToDoDurumGuncelle(Data) {
      this.Update("tlptaleptodolist", Data)
    },
    DurumGuncelle(Kod) {
      this.FormData.Lastmodifiedby = this.TokenUserId
      this.FormData.Durumid = this.FormDataType.Durumid.ComboDataArray.find(item => item.Kod === Kod).id;
      this.Update("tlptalep", this.FormData)
    },
    FileUpload2(event) {
      var file = event.target.files[0];
      if (!file) return;

      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (uzanti == "png" || uzanti == "jpeg" || uzanti == "jpg" || uzanti == "docx" || uzanti == "xlsx" || uzanti == "pdf" || uzanti == "tar" || uzanti == "zip") {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Tlp",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {

            this.Belgeler.push({
              Filename: file.name,
              Fileurl: res.Data.filename,
              dosya_uzantisi: "." + uzanti
            })
            this.$toast.success("Dosya yüklendi");

          } else {
            this.$toast.error("Dosya yüklenmedi!");
          }
        });
      }
      else {
        this.$toast.error("Hatalı Dosya Uzantısı!");
      }
    },

    
    FileUploadSartname(event) {
      var file = event.target.files[0];
      if (!file) return;

      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (uzanti == "png" || uzanti == "jpeg" || uzanti == "jpg" || uzanti == "docx" || uzanti == "xlsx" || uzanti == "pdf" || uzanti == "tar" || uzanti == "zip") {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Tlp",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {

            this.FormData.Sartnamedosyayolu = res.Data.filename
            
            this.$toast.success("Dosya yüklendi");
            this.Update("tlptalep", this.FormData)

          } else {
            this.$toast.error("Dosya yüklenmedi!");
          }
        });
      }
      else {
        this.$toast.error("Hatalı Dosya Uzantısı!");
      }
    },
  Sartnamesil(){
              this.FormData.Sartnamedosyayolu = null
              this.Update("tlptalep", this.FormData)
  },
    FileUploadTeknikDokuman(event) {
      var file = event.target.files[0];
      if (!file) return;

      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (uzanti == "png" || uzanti == "jpeg" || uzanti == "jpg" || uzanti == "docx" || uzanti == "xlsx" || uzanti == "pdf" || uzanti == "tar" || uzanti == "zip" || uzanti == "md") {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Tlp",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {

            this.FormData.Teknikdokumandosyayolu = res.Data.filename

            this.$toast.success("Dosya yüklendi");
            this.Update("tlptalep", this.FormData)

          } else {
            this.$toast.error("Dosya yüklenmedi!");
          }
        });
      }
      else {
        this.$toast.error("Hatalı Dosya Uzantısı!");
      }
    },
  TeknikDokumanSil(){
              this.FormData.Teknikdokumandosyayolu = null
              this.Update("tlptalep", this.FormData)
  },
    BelgeSil(index) {
      this.Belgeler.splice(index, 1)
    },
    BildirimGonder(){
      if(this.BildirimMesaji && this.BildirimTip){
        this.BildirimButton = true
        var FormData={
          Talepid: this.Talepid,
          Personelid: this.TokenPersonelId,
          Mesaj: this.BildirimMesaji,
          Gonderildi: true,
          Okundu: false,
          Tip: this.BildirimTip
        }
        this.Post("tlptalepbildirim", FormData).then((res) => {
          if (res) {
              this.ModalOpen = false
              this.BildirimMesaji = null
          }
          this.BildirimButton = false
        })
      }
      else{
        
        this.$toast.error("Mesaj ve Tip Alanını Doldurun");
      }
    }

  },
  created() {
 
    if(this.UserRolles.find(item => item === "SuperAdmin"  || item === "TlpAdmin" 
    || item === "TlpBirim" || item === "TlpMerkez" || item === "TlpAtananPersonel")){
      this.YonetimYetki = true
    }
    else{
      this.YonetimYetki = false
    }
    this.ActionsFilterGet({
      Service: "tlphaziryanitlar",
      FullData: true,
      Filter: "&Desc=Created",
    }).then((res) => {
      this.HazirYanitlar = res.Data.map(item => ({
        id: item.Id,
        label: item.Baslik,
        metin: item.Metin
      }));
    });
    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=4" }).then((res) => {
      this.Durumlar = res.Data.map(item => ({
        id: item.Id,
        label: item.Value,
        Kod: item.Kod
      }));
    });

    this.ToDoGet()
  }
};
</script>
<style>
.custom-file-input {
  position: relative;
  overflow: hidden;
  width: 30px;
  height: 30px;
  color: rgb(0, 0, 0);
}

.custom-file-input input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
 
      <div class="row" v-if="TalepData">


        <b-modal v-model="ModalOpen"   title="Bildirim Gönder"   hide-footer>
          <Form @submit.prevent="BildirimGonder"  >  
            <b-form-group class="col-lg-12" label="Bildirim Mesajı"  >
                  <textarea class="form-control" v-model="BildirimMesaji"   type="text" ></textarea> 
            </b-form-group> 
            <b-form-group class="col-lg-12" label="Bildirim Tipi"  >
              <select class="form-select"  v-model="BildirimTip"   >
                <option value="">{{ $t("ortakkullanim.seciniz") }}</option> 
                <option value=1>Uygulama</option> 
                <option value=2>E-Posta</option> 
                <option value=3>SMS</option> 
              </select> 
            </b-form-group> 
            <button class="btn btn-primary" type="submit" :disabled="BildirimButton">
              Kaydet
            </button>
          </Form>
        </b-modal>
        

        <div class="col-md-8">
          <div class="row">

            <!-- Talep Bilgileri -->
            <div class="col-lg-7">
              <div class="card">
                <div class="card-body">
                  <div class="invoice-title">
                    <h4 class="float-end font-size-16"></h4>
                    <div class="mb-4 font-size-16"> Talep Bilgileri
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-6">
                      <address><strong>Takip No:</strong><br> {{ TalepData.Takipno }} </address>
                      <address><strong>Başlık:</strong><br> {{ TalepData.Baslik }} </address>
                      <address><strong>Talep Sahibi:</strong><br> {{ TalepData.Olusturan }} <span v-if="TalepData.Talepsahibidahili"> / ({{ TalepData.Talepsahibidahili }})</span>   </address>
                      <address><strong>Tahmini Bitiş Zamanı:</strong><br> {{ TalepData.Tahminibitis ?
                        formatDateTable(TalepData.Tahminibitis) : '' }}</address>
                      <address><strong>Destek Öncelik:</strong><br> {{ TalepData.Destekoncelik }} </address>
                      <address
                        v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpBirim")).length > 0'>
                        <strong>İş Gücü</strong><br> {{ TalepData.Isgucu }} </address>
                      <address
                        v-if='APPLICATION_TYPE == 1 && UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpBirim") || item.includes("TlpMerkez")).length > 0'>
                        <strong>Ücretli</strong><br> {{ TalepData.Ucretli == true ? 'Evet' : 'Hayır' }} </address> 
                    </div>
                    <div class="col-6 text-sm-end">
                      <address><strong>Talep Tip</strong><br> {{ TalepData.Taleptip }} </address>
                      <address><strong>Birim</strong><br> {{ TalepData.Atananbirim }} </address>
                      <address><strong>Talep Sahibi Birim:</strong><br> {{ TalepData.Talepsahibibirim }} </address>
                      <address><strong>Durum</strong><br> {{ TalepData.Durum }} </address>
                      <address><strong>Öncelik</strong><br> {{ TalepData.Oncelik }} </address>
                      <address v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpBirim") || item.includes("TlpMerkez")).length > 0'
                      ><strong>Atanan Personel</strong><br> {{ TalepData.Atananpersonel }} </address>

                      <address><strong>Oluşturulma Zamanı</strong><br>  {{ TalepData.Created != null ? formatDateTable(TalepData.Created) : '' }} </address>
                     
                    </div>
                    <address><strong>Açıklama:</strong><br> <p v-html="TalepData.Aciklama"></p> </address>

                    <div class="col-12 text-sm-end">
                      <b-button-group v-if="FormDataType">  

                        <b-button v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpMerkez")).length > 0 &&
                          9 == TalepData.DurumKod' v-b-tooltip.hover title="Tamamlandı" variant="warning"
                          @click="DurumGuncelle('7')"><i class="fas fa-check"></i> Tamamlandı</b-button>

                        <b-button v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpBirim")).length > 0 &&
                          8 == TalepData.DurumKod' v-b-tooltip.hover title="Birim Tamamlandı" variant="warning"
                          @click="DurumGuncelle('9')"><i class="fas fa-check"></i> Birim Tamamlandı</b-button>

                        <b-button v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpAtananPersonel")).length > 0 &&
                          4 == TalepData.DurumKod' v-b-tooltip.hover title="Personel Tamamlandı" variant="warning"
                          @click="DurumGuncelle('8')"><i class="fas fa-check"></i> Personel Tamamlandı</b-button>

                        <b-button v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpAtananPersonel")).length > 0 &&
                          4 == TalepData.DurumKod' v-b-tooltip.hover title="İncelemeye ihtiyaç var" variant="info"
                          @click="DurumGuncelle('5')"><i class="fas fa-check"></i> İncelemeye ihtiyaç var</b-button>


                        <b-button v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpAtananPersonel")).length > 0 &&
                          2 == TalepData.DurumKod' v-b-tooltip.hover title="İşlemde  " variant="warning"
                          @click="DurumGuncelle('4')"><i class="fas fa-check"></i> İşlemde</b-button>




                        <b-button v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpMerkez")).length > 0 &&
                          7 == TalepData.DurumKod' v-b-tooltip.hover title="Birim Tamamlandı" variant="danger"
                          @click="DurumGuncelle('9')">X Birim Tamamlandı</b-button>

                        <b-button v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpBirim")).length > 0 &&
                          9 == TalepData.DurumKod' v-b-tooltip.hover title="Personel Tamamlandı" variant="danger"
                          @click="DurumGuncelle('8')">X Personel Tamamlandı</b-button>


                        <b-button v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpAtananPersonel")).length > 0 &&
                          (8 == TalepData.DurumKod || 5 == TalepData.DurumKod)' v-b-tooltip.hover title="İşlemde" variant="danger"
                          @click="DurumGuncelle('4')">X İşlemde</b-button>


                           
                        <b-button variant="primary"   v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpMerkez") || item.includes("TlpBirim")).length > 0'
                        title="Personele Bildirim Gönder" @click="ModalOpen = true"><i
                            class="far fa-add"></i>Personele Bildirim Gönder</b-button>


                            
                        <b-button 
                        v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpMerkez") ).length > 0'
                        variant="success" v-b-modal.tlptalep title="Talep Düzenle" @click="DataUpdate = TalepData, AddEdit = 'Edit'" ><i class="far fa-add"></i>Talep Düzenle</b-button>

                         

                      </b-button-group>




                    </div>


                  </div>

                </div>
              </div>
            </div>
            <!-- Talep Bilgileri -->

            <!-- Talep Belgeleri -->
            <div class="col-lg-5">
              <div class="card">
                <div class="card-body">

                  <div class="invoice-title">
                    <div class="mb-4 font-size-16"> Talep Belgeleri
                    </div>
                  </div>
                  <hr>
                  <div class="table-responsive" v-if="TalepBelgeler.length != 0">
                    <table class="table b-table table-bordered mb-0">
                      <thead class="">
                        <tr>
                          <th scope="colspan" class="">Başlık</th>
                          <th scope="colspan" class="">Belge</th>
                        </tr>

                      </thead>
                      <tbody class="">
                        <tr class="" v-for="(Data, index) in TalepBelgeler" :key="index">
                          <td scope="col" class="">{{ Data.Baslik }}</td>
                          <td scope="col" class=""><a target="_blank" :href="FILES_URL + '/Tlp/' + Data.Dosyayolu">
                              Görüntülemek İçin Tıklayın </a>
                            <i class="far fa-trash-alt" @click="Delete('tlptalepbelge', Data.Id)"></i>
                          </td>

                        </tr>
                        <tr class="" v-if="TalepBelgeler.length == 0">
                          <td scope="col" class="text-center" colspan="2"> Kayıt Bulunamadı</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row"
                    v-if="!(FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '7').id == FormData.Durumid)">
                    <b-form-group class="col-md-6" label="Belge">
                      <input class="form-control upload-input col-md-12 mt-3" ref="file" type="file"
                        @change="FileUpload($event)" id="FormData.IcerikDosya"
                        accept=".jpg, .jpeg, .png, .12, .pdf, .docx, .tar, .zip" />
                    </b-form-group>
                    <b-form-group class="col-md-6" label="Başlık">
                      <b-form-input v-model="BelgeBaslik"></b-form-input>


                    </b-form-group>
                  </div>

                  <div class="d-print-none">
                    <div class="float-end"><a class="btn btn-success waves-effect waves-light me-1"
                        href="javascript:window.print()" target="_self"><i class="fa fa-print"></i></a>


                      <b-button-group
                        v-if="!(FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '7').id == FormData.Durumid)">
                        <b-button variant="primary" v-b-tooltip.hover title="Gönder" @click="BelgeGonder()"><i
                            class="far fa-add"></i>Kaydet</b-button>
                      </b-button-group>


                    </div>
                  </div>
                </div>


                
                <div class="card-body" v-if="FormData.Ucretli == true">

                  <div class="invoice-title">
                    <div class="mb-4 font-size-16"> Şartname
                    </div>
                  </div>
                  <hr>
                  <div class="table-responsive" >
                    <table class="table b-table table-bordered mb-0">
                      <thead class="">
                        <tr> 
                          <th scope="colspan" class="">Belge</th>
                        </tr>

                      </thead>
                      <tbody class="">
                        <tr class=""  v-if="FormData.Sartnamedosyayolu"> 
                          <td scope="col" class=""> {{ FormData.Sartnamedosyayolu }}<a target="_blank" :href="FILES_URL + '/Tlp/' + FormData.Sartnamedosyayolu">
                              Görüntülemek İçin Tıklayın </a>
                            <i class="far fa-trash-alt" @click="Sartnamesil()"></i>
                          </td>

                        </tr>
                        <tr class="" v-if="!FormData.Sartnamedosyayolu">
                          <td scope="col" class="text-center" colspan="2"> Kayıt Bulunamadı</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row" >
                    <b-form-group class="col-md-6" label="Belge">
                      <input class="form-control upload-input col-md-12 mt-3" ref="file" type="file"
                        @change="FileUploadSartname($event)" id="FormData.IcerikDosya"
                        accept=".jpg, .jpeg, .png, .12, .pdf, .docx, .tar, .zip" />
                    </b-form-group>
                  </div>

                </div>

                <div class="card-body" v-if="APPLICATION_TYPE == 1 && YonetimYetki">

                  <div class="invoice-title">
                    <div class="mb-4 font-size-16"> Teknik Döküman
                    </div>
                  </div>
                  <hr>
                  <div class="table-responsive" >
                    <table class="table b-table table-bordered mb-0">
                      <thead class="">
                        <tr>
                          <th scope="colspan" class="">Belge</th>
                        </tr>

                      </thead>
                      <tbody class="">
                        <tr class=""  v-if="FormData.Teknikdokumandosyayolu">
                          <td scope="col" class=""> {{ FormData.Teknikdokumandosyayolu }}<a target="_blank" :href="FILES_URL + '/Tlp/' + FormData.Teknikdokumandosyayolu">
                              Görüntülemek İçin Tıklayın </a>
                            <i class="far fa-trash-alt" @click="TeknikDokumanSil()"></i>
                          </td>

                        </tr>
                        <tr class="" v-if="!FormData.Teknikdokumandosyayolu">
                          <td scope="col" class="text-center" colspan="2"> Kayıt Bulunamadı</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row" >
                    <b-form-group class="col-md-6" label="Belge">
                      <input class="form-control upload-input col-md-12 mt-3" type="file"
                        @change="FileUploadTeknikDokuman($event)" id="FormData.TeknikDokumanDosya"
                        accept=".jpg, .jpeg, .png, .12, .pdf, .docx, .xlsx, .tar, .zip, .md" />
                    </b-form-group>
                  </div>

                </div>

              </div>
            </div>
            <!-- Talep Belgeleri -->


            
          </div>

          <!-- Mesajlar -->
          <div class="col-lg-12 col-xl-12">
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
                    <h4 class="card-title mb-3">Mesajlar</h4>
                  </div>
                </div>
                <div data-simplebar="" style="max-height: 500px;" class="simplebar-scrollable-y">
                  <div class="simplebar-wrapper" style="margin: 0px;">
                    <div class="simplebar-height-auto-observer-wrapper">
                      <div class="simplebar-height-auto-observer"></div>
                    </div>
                    <div class="simplebar-mask">
                      <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                        <div class="simplebar-content-wrapper" tabindex="0" role="region"
                          aria-label="scrollable content" style="height: auto; overflow: hidden scroll;">
                          <div class="simplebar-content" style="padding: 0px;">
                            <div class="list-group" v-if="TalepNot">

                              <template v-for="(Data, index) in TalepNot" :key="index">
                                <div class="list-group-item py-3" v-if="Data.Personeltipkod != 1">
                                  <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                      <div class="avatar-title rounded-circle bg-light text-primary"><i
                                          class="bx bxs-user"></i></div>
                                    </div>
                                    <div class="flex-grow-1">
                                      <h5 class="font-size-14 mb-1" 
                                      v-if='APPLICATION_TYPE != "3" || (APPLICATION_TYPE == "3" &&
UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpBirim") || item.includes("TlpMerkez")).length > 0
                                      )'> {{ Data.Olusturan }}<small
                                          class="text-muted float-end"> {{ formatDateTableTime(Data.Created) }} 
                                        
                                        <a class="text-danger p-1"  v-if="YonetimYetki"
                                                    @click="Delete('tlptalepnot', Data.Id)"
                                                    href="javascript: void(0);" target="_self"><i
                                                      class="bx bxs-trash"></i></a>
                                        </small>
                                      </h5>  
                                      <p class="text-muted" v-html="Data.Aciklama"> </p>
                                      <div class="row">
                                        <div class="col-md-10">
                                          <template class="" v-for="(Data, index) in JSON.parse(Data.Belgeler)"
                                            :key="index">
                                            <a target="_blank" :href="FILES_URL + '/Tlp/' + Data.dosyayolu">
                                              <span style="margin-right: 10px; color: #ff69b4" class="fas fa-file-image"
                                                v-if="(Data.dosya_uzantisi == '.png' || Data.dosya_uzantisi == '.jpg' || Data.dosya_uzantisi == '.jpeg')"></span>
                                              <span style="margin-right: 10px; color: green" class="fas fa-file-excel"
                                                v-if="Data.dosya_uzantisi == '.xlsx'"></span>
                                              <span style="margin-right: 10px; color: purple" class="fas fa-file-pdf"
                                                v-if="Data.dosya_uzantisi == '.pdf'"></span>
                                              <span style="margin-right: 10px; color: blue" class="fas fa-file-word"
                                                v-if="Data.dosya_uzantisi == '.docx'"></span>
                                            </a>
                                            {{ Data.baslik }}
                                            <i class="far fa-trash-alt" @click="Delete('tlptalepbelge', Data.id)"></i>
                                            &nbsp;&nbsp;&nbsp;
                                          </template>
                                        </div>
                                        <div class="col-md-2"
                                          v-if="!(FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '7').id == FormData.Durumid)">
                                          <div class="custom-file-input float-end"> <i class="fas fa-upload"></i> <input
                                              ref="file" type="file" @change="FileUpload($event, Data.Id)"
                                              accept=".jpg, .jpeg, .png, .12, .pdf, .docx, .tar, .zip"> </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                                <div class="list-group-item py-3" v-else>
                                  <div class="d-flex">
                                    <div class="avatar-xs me-3"><img
                                        src="/skote/vuejs/v-light/img/avatar-2.a04c367f.jpg" alt=""
                                        class="img-fluid d-block rounded-circle"></div>
                                    <div class="flex-grow-1">


                                      <div class="d-flex">
                                        <div class="flex-shrink-0 me-3">
                                          <div class="avatar-xs">
                                            <div class="avatar-title rounded-circle bg-light text-primary"><i
                                                class="bx bxs-user"></i></div>
                                          </div>
                                        </div>
                                        <div class="flex-grow-1">
                                          <h5 class="font-size-14 mb-1"> {{ Data.Olusturan }}<small
                                              class="text-muted float-end"> {{
                                                formatDateTableTime(Data.Created)
                                              }}</small></h5>
                                          <p class="text-muted">{{ Data.Aciklama }}</p>
                                          <div class="row">
                                            <div class="col-md-10">
                                              <template class="" v-for="(Data, index) in JSON.parse(Data.Belgeler)"
                                                :key="index">
                                                <a target="_blank" :href="FILES_URL + '/Tlp/' + Data.dosyayolu">
                                                  <span style="margin-right: 10px; color: #ff69b4"
                                                    class="fas fa-file-image"
                                                    v-if="(Data.dosya_uzantisi == '.png' || Data.dosya_uzantisi == '.jpg' || Data.dosya_uzantisi == '.jpeg')"></span>
                                                  <span style="margin-right: 10px; color: green"
                                                    class="fas fa-file-excel"
                                                    v-if="Data.dosya_uzantisi == '.xlsx'"></span>
                                                  <span style="margin-right: 10px; color: purple"
                                                    class="fas fa-file-pdf" v-if="Data.dosya_uzantisi == '.pdf'"></span>
                                                  <span style="margin-right: 10px; color: blue" class="fas fa-file-word"
                                                    v-if="Data.dosya_uzantisi == '.docx'"></span>
                                                </a>
                                                {{ Data.baslik }}
                                                <i class="far fa-trash-alt"
                                                  @click="Delete('tlptalepbelge', Data.id)"></i> &nbsp;&nbsp;&nbsp;
                                              </template>
                                            </div>
                                            <div class="col-md-2"
                                              v-if="!(FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '7').id == FormData.Durumid)">
                                              <div class="custom-file-input float-end"> <i class="fas fa-upload"></i>
                                                <input ref="file" type="file" @change="FileUpload($event, Data.Id)"
                                                  accept=".jpg, .jpeg, .png, .12, .pdf, .docx, .tar, .zip">
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="simplebar-placeholder" style="width: 479px; height: 481px;"></div>
                  </div>



                </div> <b-form-group
                  v-if="!(FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '7').id == FormData.Durumid)"
                  label="Mesaj" class="mt-3">
                  <textarea v-model="Mesaj" class="form-control"></textarea>
                  
                </b-form-group>

                
                <div class="row">
                  <div class="col-md-10">


                    <template class="" v-for="(Data, index) in Belgeler" :key="index">
                      <a target="_blank" :href="FILES_URL + '/Tlp/' + Data.Fileurl">
                        <span style="margin-right: 10px; color: #ff69b4" class="fas fa-file-image"
                          v-if="(Data.dosya_uzantisi == '.png' || Data.dosya_uzantisi == '.jpg' || Data.dosya_uzantisi == '.jpeg')"></span>
                        <span style="margin-right: 10px; color: green" class="fas fa-file-excel"
                          v-if="Data.dosya_uzantisi == '.xlsx'"></span>
                        <span style="margin-right: 10px; color: purple" class="fas fa-file-pdf"
                          v-if="Data.dosya_uzantisi == '.pdf'"></span>
                        <span style="margin-right: 10px; color: blue" class="fas fa-file-word"
                          v-if="Data.dosya_uzantisi == '.docx'"></span>
                      </a>
                      {{ Data.Filename }}
                      <i class="far fa-trash-alt" @click="BelgeSil(index)"></i>
                      &nbsp;&nbsp;&nbsp;
                    </template>
                  </div>
                  <div class="col-md-2"> 
                    <div class="float-end"> <input ref="file" type="file" @change="FileUpload2($event)"
                        accept=".jpg, .jpeg, .png, .12, .pdf, .docx, .tar, .zip"> </div>
                  </div>
                </div>

                

                <div class="d-print-none">
                  <div class="d-flex justify-content-end align-items-center">

                    <b-form-group class="me-3 mb-0 col-md-3" label-for="text" label="Hazır Yanıtlar"
                      v-if="TokenPersonelId != FormData.Olusturanid && !(FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '7').id == FormData.Durumid)">
                      <treeselect :multiple="false" :options="HazirYanitlar" v-model="HazirYanit"
                        placeholder="Seçiniz..." />
                    </b-form-group>



                    <b-form-group label="Talebi Kapat"
                      v-if="UserRolles.filter((item) => item.includes('SuperAdmin') || item.includes('TlpAdmin') || item.includes(' ')).length > 0 &&
                        TokenPersonelId != FormData.Olusturanid && !(FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '7').id == FormData.Durumid)">
                      <b-form-checkbox v-model="TalebiKapat" class="mb-3"></b-form-checkbox>
                    </b-form-group>

                    <b-button-group
                      v-if="!(FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '7').id == FormData.Durumid)">
                      <b-button variant="primary" v-b-tooltip.hover title="Gönder" @click="NotGonder()"
                        :disabled="isSubmitting"><i class="far fa-add"></i>Gönder</b-button>
                    </b-button-group>

                  </div>




                </div>
              </div>
            </div>
          </div>
          <!-- Mesajlar -->

        </div>


        <div class="col-md-4">

          <!-- Talep Formu -->
          <div class="col-xl-12" v-if="!YonetimYetki">
            <div class="card">
              <div class="card-body" v-if="FormData">

                <div class="invoice-title">
                  <h4 class="float-end font-size-16"></h4>
                  <div class="mb-4 font-size-16"> Talep Bilgileri
                  </div>
                </div>
                <hr>
                <div class="card">
                  <div class="card-body">


                    <div class="d-flex">


                      <Form @submit.prevent="onSubmit" v-if="FormData">

                        <div class="row mt-3">

                          <forminput class="col-lg-6" :FormDataType="FormDataType.Baslik" :Value="FormData.Baslik"
                            :v="v$.FormData.Baslik" @input="FormData.Baslik = $event.target.value" :disabled="FormDataType.Baslik.Disabled"/>

                          <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Taleptipid.FieldTitle"
                            :key="FormData.Taleptipid">
                            <treeselect :multiple="false" :options="FormDataType.Taleptipid.ComboDataArray"
                              placeholder="Seçiniz..." v-model="FormData.Taleptipid"
                              :disabled="FormDataType.Atananpersonelid.Disabled" />
                            <treeselect-value :value="FormData.Taleptipid" />
                          </b-form-group>

                          <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Atananbirimid.FieldTitle"
                            :key="FormData.Atananbirimid">
                            <treeselect :multiple="false" :options="FormDataType.Atananbirimid.ComboDataArray"
                              placeholder="Seçiniz..." v-model="FormData.Atananbirimid"
                              :disabled="FormDataType.Atananpersonelid.Disabled" />
                            <treeselect-value :value="FormData.Atananbirimid" />
                          </b-form-group>

                          <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Durumid.FieldTitle"
                            :key="FormData.Durumid">
                            <treeselect :multiple="false" :options="FormDataType.Durumid.ComboDataArray"
                              placeholder="Seçiniz..." v-model="FormData.Durumid"
                              :disabled="FormDataType.Atananpersonelid.Disabled" />
                            <treeselect-value :value="FormData.Durumid" />
                          </b-form-group>

                          <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Oncelikid.FieldTitle"
                            :key="FormData.Oncelikid">
                            <treeselect :multiple="false" :options="FormDataType.Oncelikid.ComboDataArray"
                              placeholder="Seçiniz..." v-model="FormData.Oncelikid"
                              :disabled="FormDataType.Atananpersonelid.Disabled" />
                            <treeselect-value :value="FormData.Oncelikid" />
                          </b-form-group>

                          <b-form-group class="col-lg-6" label-for="text"
                            :label="FormDataType.Atananpersonelid.FieldTitle"
                            v-if="TokenPersonelId != FormData.Olusturanid" :key="FormData.Atananpersonelid">
                            <treeselect :multiple="false" :options="FormDataType.Atananpersonelid.ComboDataArray"
                              placeholder="Seçiniz..." v-model="FormData.Atananpersonelid"
                              :disabled="FormDataType.Atananpersonelid.Disabled" />
                            <treeselect-value :value="FormData.Atananpersonelid" />
                          </b-form-group>

                          <formdate class="col-lg-6" :FormDataType="FormDataType.Tahminibitis"
                            v-if="TokenPersonelId != FormData.Olusturanid" :Value="FormData.Tahminibitis"
                            :v="v$.FormData.Tahminibitis" @input="FormData.Tahminibitis = $event.target.value" />

                          <formtextarea class="col-lg-12" :FormDataType="FormDataType.Aciklama"
                            :Value="FormData.Aciklama" :v="v$.FormData.Aciklama"
                            @input="FormData.Aciklama = $event.target.value" :disabled="FormDataType.Aciklama.Disabled" />
                        </div>
                        <div class="float-end"> <button class="btn btn-primary" type="submit"
                            v-if="!(FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '7').id == FormData.Durumid) && 0">
                            Güncelle
                          </button></div>
                      </Form>
                    </div>

                  </div>
                </div>


              </div>
            </div>
          </div>
          <!-- Talep Formu -->


          <!-- Yapılacak Listesi -->
          <div class="col-xl-12" v-if="YonetimYetki">
            <div class="card">
              <div class="card-body" v-if="FormData">

                <div class="invoice-title">
                  <h4 class="float-end font-size-16"></h4>
                  <div class="mb-4 font-size-16"> Yapılacak İşlemler
                  </div>
                </div>
                <hr>

                <div class="card">
                  <div class="card-body">


                    <div class="row">
                      <div class="col-md-10">

                        <b-form-group label="Metin">
                          <b-form-input v-model="ToDoFormData.Metin"></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-2">

                        <b-button-group class="mt-4">
                          <b-button variant="primary" v-b-tooltip.hover title="Gönder" @click="ToDoGonder()"><i
                              class="far fa-add"></i>{{ ToDoFormData.Id ? 'Güncelle' : 'Gönder' }}</b-button>
                        </b-button-group>
                      </div>
                    </div>


                    <div class="tab-pane active show fade" role="tabpanel" aria-labelledby="__BVID__506410___BV_tab__">
                      <div data-simplebar="init" style="max-height: 250px;" class="simplebar-scrollable-y">
                        <div class="simplebar-wrapper" style="margin: 0px;">
                          <div class="simplebar-height-auto-observer-wrapper">
                            <div class="simplebar-height-auto-observer"></div>
                          </div>
                          <div class="simplebar-mask">
                            <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                              <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                aria-label="scrollable content" style="height: auto; overflow: hidden scroll;">
                                <div class="simplebar-content" style="padding: 0px;">
                                  <div class="table-responsive">
                                    <table class="table b-table table-nowrap align-mid table-hover mb-0">
                                      <tbody class="">
                                        <tr class="" v-for="(Data, index) in ToDoList" :key="index">

                                          <td scope="col" class="" style="width: 50px;">



                                            <div class="form-check">

                                              <b-form-checkbox v-model="Data.Durum" class="mb-3"
                                                @change="ToDoDurumGuncelle(Data)"></b-form-checkbox>

                                            </div>
                                          </td>
                                          <td scope="col" class="">
                                            <h5 class="text-truncate font-size-14 mb-1"><a class="text-dark text-wrap d-block"
                                                href="javascript: void(0);" target="_self">{{ Data.Metin }}</a>
                                            </h5>
                                            <p class="text-muted mb-0">

                                              {{ Data.Personel }} - {{ Data.Created ? formatDateTableTime(Data.Created)
                                              : '' }}
                                            </p>
                                          </td>
                                          <td scope="col" class="" style="width: 90px;">
                                            <div>
                                              <ul class="list-inline mb-0 font-size-16">
                                                <li class="list-inline-item"  ><a class="text-success p-1"
                                                  @click="ToDoFormData = Data"
                                                    href="javascript: void(0);" target="_self"><i
                                                      class="bx bxs-edit-alt"></i></a></li>
                                                <li class="list-inline-item"><a class="text-danger p-1"
                                                    @click="Delete('tlptaleptodolist', Data.Id)"
                                                    href="javascript: void(0);" target="_self"><i
                                                      class="bx bxs-trash"></i></a></li>
                                              </ul>
                                            </div>
                                          </td>
                                        </tr>

                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="simplebar-placeholder" style="width: 479px; height: 473px;"></div>
                        </div>

                      </div>
                    </div>


                  </div>
                </div>


              </div>
            </div>
          </div>
          <!-- Yapılacak Listesi -->

          <!-- Talep Geçmişi -->
          <div class="col-md-12" v-if="YonetimYetki">
            <div class="col-xl-12">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="me-2">
                      <h4 class="card-title mb-4">Talep Geçmişi</h4>
                    </div>

                  </div>
                  <div data-simplebar="" class="mt-2 simplebar-scrollable-y" style="max-height: 400px;"
                    v-if="TalepGecmis">
                    <div class="simplebar-wrapper" style="margin: 0px;">
                      <div class="simplebar-height-auto-observer-wrapper">
                        <div class="simplebar-height-auto-observer"></div>
                      </div>
                      <div class="simplebar-mask">
                        <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                          <div class="simplebar-content-wrapper" tabindex="0" role="region"
                            aria-label="scrollable content" style="height: auto; overflow: hidden scroll;">
                            <div class="simplebar-content" style="padding: 0px;">
                              <ul class="verti-timeline list-unstyled">
                                <li class="event-list " v-for="(Data, index) in TalepGecmis" :key="index"
                                
                                >
                                  <div class="event-timeline-dot"><i
                                      class="bx bxs-right-arrow-circle font-size-18 bx-fade-right text-primary"></i>
                                  </div>
                                  <div class="d-flex ">
                                    <div class="me-3 ">
                                      <h5 class="font-size-14">{{ formatDateTableTime(Data.Created) }} <i
                                          class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                                      </h5>
                                    </div>
                                    <div class="flex-grow-1">
                                      <div>
                                        <h5 class="font-size-14 mb-1 "
                                        :class="Data.Oncekidurum == 'Atanan Personel İşlemleri Tamamladı' && Data.Yenidurum == 'İşlemde' ? 'bg-warning p-2' : '' "
                                        >İşlemi Yapan: {{ Data.Olusturan }} </h5>
                                        <p class="text-muted">Değişiklik: {{ Data.Aciklama }}</p>
                                        <p class="text-muted" v-if="Data.Oncekidurum">Önceki Durum: {{ Data.Oncekidurum
                                          }}</p>
                                        <p class="text-muted" v-if="Data.Yenidurum">Yeni Durum: {{ Data.Yenidurum }}</p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="simplebar-placeholder" style="width: 479px; height: 336px;"></div>
                    </div>

                  </div>
                </div>
              </div>
            </div>


          </div>
          <!-- Talep Geçmişi -->

        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get"  v-if='UserRolles.filter((item) => item.includes("SuperAdmin") || item.includes("TlpAdmin") || item.includes("TlpMerkez") ).length > 0' />
    </Layout>
  </Loader>
</template>
